import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=dc76b416&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc76b416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc76b416')) {
      api.createRecord('dc76b416', component.options)
    } else {
      api.reload('dc76b416', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=dc76b416&scoped=true", function () {
      api.rerender('dc76b416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/Main.vue"
export default component.exports